const s = {
  name: "Rollerskate",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M28,35c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S28,34.4,28,35z"/>
		<path class="st0" d="M18,15.2l11.5,2.9c5,1.3,8.5,5.8,8.5,10.9v3h2v6h-6v-6h2v-2h-9c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5s-5-2.2-5-5
			c0-2.8,2.2-5,5-5H5c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5H0V5l16-1.9V0h2V15.2z M16,5.1L2,6.8v13.3
			c4.2,0.5,7.5,3.8,7.9,7.9h26c-0.4-3.8-3.2-7-6.9-8l-13-3.2V15H9v-2h7v-2H9V9h7V5.1z M2,28h5.9c-0.4-3.1-2.9-5.5-5.9-5.9V28z M2,35
			c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3C3.3,32,2,33.3,2,35z M27,32c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3
			C30,33.3,28.7,32,27,32z M36,36h2v-2h-2V36z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Rollerskate
};
